module.exports = __webpack_public_path__ + "assets/img/pt-6733b3f9.png";